import { Component, Inject, input, InputSignal } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';

@Component({
  selector: 'app-dialog-wrapper',
  templateUrl: './dialog-wrapper.component.html',
  styleUrl: './dialog-wrapper.component.scss'
})
export class DialogWrapperComponent {
  closable: InputSignal<boolean> = input<boolean>(true);
  icon: InputSignal<string | null> = input<string | null>(null);

  isFooterVisible: InputSignal<boolean> = input<boolean>(true);

  constructor(
    @Inject(DIALOG_DATA) public data: any,
    private dialogRef: DialogRef
  ) {}

  onCloseClick() {
    this.dialogRef.close();
  }
}
